const anyDefaultConstants = {
  defaultSpecialCourseId: {},
  defaultSpecialCourseIdsInSubscription: {
    388: 306,
    385: 391,
    393: 391
  },
  defaultPaywallServiceId: 3419,
  defaultLinkQuiz: 'https://anyclass.com/landings/ff_school_up_lk_quiz',
  coursesForShowModalNewOffer: [388, 385, 393],
  coursesForHideModalNewOffer: [306, 391]
}

export default anyDefaultConstants
